const LicenseInfoService = require('./LicenseInfoService');

class LicenseInfo {
  constructor(view) {
    this.view = view;

    this.lastSelectedReprint = localStorage.getItem('lastSelectedReprint');
    this.lastSelectedWeek = localStorage.getItem('lastSelectedWeek');
    this.licenseInfoService = new LicenseInfoService();

    this.configureElements();
    this.bindElements();
    this.hideLicenseTypeIfOnlyOneLicense();
    this.populateWeeks();
  }

  configureElements() {
    this.view.licenseTypeSelect.find('option').prop('disabled', false);

    this.view.licenseTypeSelect.select2({
      placeholder: 'Select License Type',
      minimumResultsForSearch: Infinity
    });

    this.view.weeksSelect.select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: 'loading...'
    });
  }

  bindElements() {
    const view = this.view;

    view.bind(this.view.licenseTypeSelect, 'select2:select', (e) => {
      this.onLicenseSelect(e);
    }).change().trigger('select2:select');

    view.bind(this.view.licenseTypeSelect, 'weeks-loaded', (e) => {
      this.onWeeksLoaded(e);
    });
  }

  getLicenseTypeVal() {
    return this.view.licenseTypeSelect.val();
  }

  getWeeksVal() {
    return this.view.weeksSelect.val();
  }

  hideLicenseTypeIfOnlyOneLicense() {
    const optionsLength = this.view.licenseTypeSelect.find('option').length;

    if (optionsLength === 1) {
      this.view.licenseTypeContainer.hide();
    }
  }

  disableLicenseBasedOnSongType() {
    if (typeof this.view.buttonData === 'undefined') return;

    const licenseTypeSelect = this.view.licenseTypeSelect;
    const selectedOption = licenseTypeSelect.find('option:selected');

    const master = this.view.buttonData.master;
    const reprint = this.view.buttonData.reprint;

    if ((!reprint && !master) || (reprint && master)) return;

    if (reprint) {
      licenseTypeSelect.find('option[data-is-reprint=false]').prop('disabled', true);
      licenseTypeSelect.find('option[data-is-reprint=true]').prop('disabled', false);
    }

    if (master) {
      licenseTypeSelect.find('option[data-is-master=false]').prop('disabled', true);
      licenseTypeSelect.find('option[data-is-master=true]').prop('disabled', false);
    }

    if ((master && selectedOption.data('is-master') === false)
      || (reprint && selectedOption.data('is-reprint') === false)) {
      const notDisabledLicense = licenseTypeSelect.find('option:enabled').val();
      licenseTypeSelect.val(notDisabledLicense).trigger('change').trigger('select2:select');
    }
  }

  onWeeksLoaded() {
    if (!!this.lastSelectedWeek && this.lastSelectedReprint === this.getLicenseTypeVal()) {
      this.view.weeksSelect.val(this.lastSelectedWeek).trigger('change');
    }
  }

  onLicenseSelect(e) {
    this.prepareWeeksElement();
  }

  async prepareWeeksElement() {
    const licenseTypeSelect = this.view.licenseTypeSelect;
    const weeksData = licenseTypeSelect.data('weeksData') || {};
    const id = this.getLicenseTypeVal();

    if (!(id in weeksData)) {
      weeksData[id] = await this.licenseInfoService.loadWeeks(id);
      licenseTypeSelect.data('weeksData', weeksData);
    }

    this.view.weeksSelect.find('option').remove();

    $.each(weeksData[id].weeks, (i, item) => {
      this.view.weeksSelect.append($('<option>', {
        value: i,
        text: item
      }));
    });

    this.view.weeksSelect.select2({
      disabled: false,
      minimumResultsForSearch: Infinity
    });

    this.view.licenseTypeSelect.trigger('weeks-loaded');
  }

  populateWeeks() {
    const lastSelectedReprint = this.lastSelectedReprint;

    if (lastSelectedReprint) {
      const waitForSelect2 = (lastSelectedReprint) => {
        if (jQuery.fn.select2) {
          const lastSelectedReprintOption = this.view.licenseTypeSelect.find(`option[value="${lastSelectedReprint}"]`);

          if (lastSelectedReprintOption.length) {
            this.view.licenseTypeSelect.val(lastSelectedReprint);
          }

          this.view.licenseTypeSelect.trigger('change').trigger('select2:select');
        } else {
          setTimeout(() => { waitForSelect2(lastSelectedReprint); }, 500);
        }
      };
      setTimeout(() => { waitForSelect2(lastSelectedReprint); }, 500);
    }

    this.disableLicenseBasedOnSongType();
  }
}

module.exports = LicenseInfo;
